import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import httpService from "../../../services/http.service";
import "./settings.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import ErrorMessage from "../../common/errorMsg";
import SuccessMessage from "../../common/successMsg";
import Navbar from './settingNav';

const BackupLocation = (props) => {
  const [backupLocation, setBackupLocation] = useState({});
  const [update, setUpdate] = useState(false)
  const [updateNas, setUpdateNas] = useState(false)
  const [activeTab, setActiveTab] = useState("backupLocation");
  const [username, setusername] = useState("");
  const [pass, setPass] = useState("");
  const [location, setlocation] = useState("");
  const [port, setPort] = useState("");
  const [host, setHost] = useState("");
  const [saved, setSaved] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadNasModal, setUploadNasModal] = useState(false);
  const [nasCred, setNASCred] = useState({
      host: '',
      username: '',
      password: '',
      port: '',
  })

  const toggleUploadModal = () => {
    setUploadModal(!uploadModal);
  };

  // const toggleUploadNasModal = () => {
  //   setUploadNasModal(!uploadNasModal);
  // };

  const cancle = () => {
    setSaved(!saved)
    toggleUploadModal()
  }

  // const cancleNas = () => {
  //   toggleUploadNasModal()
  // }

  const saveBackupLocation = async () => {
    let data = {
      host: host,
      username: username,
      user: localStorage.getItem("Username"),
      password: pass,
      location: location,
      port: port,
    };
    let res = await httpService
      .delete("savebackuplocation", data)
      .then((res) => res.data)
      .catch((err) => {
        ErrorMessage("Could not update backup location")
      });
    if (res) {
      SuccessMessage(res.msg)
      props.setSaved(!saved);
      props.setBackupLocation(res);
    }
  };

  // const saveNASCred = async () => {
  //   let res = await httpService
  //     .delete("savebackuplocation", {...nasCred, location:"nas"})
  //     .then((res) => res.data)
  //     .catch((err) => {
  //       ErrorMessage("Could not update NAS credential")
  //     });
  //   if (res) {
  //     SuccessMessage(res.msg)
  //   }
  // };

  useEffect(() => {
    const getBackupLocation = async () => {
      let data = { user: localStorage.getItem("Username") };

      let res = await httpService
        .CreateUpdate("getbackupLocation", data)
        .then((res) => res.data)
        .catch((err) => null);
      if (res) {
        setBackupLocation(res);
        setlocation(res.location)
        setHost(res.IP)
        setPort(res.port)
        setusername(res.username)
        props.setBackupLocation(res);
        if (res.port) {
          setUpdate(true)
        }else{
          setUpdate(false)
        }
      }else{
        setUpdate(false)
      }
    };
    getBackupLocation();
  }, [saved]);

  // useEffect(() => {
  //   const x = async () => {
  //     let res = await httpService.CreateUpdate("getbackupLocation",{user: "nas"})
  //       .then((res) => res.data)
  //       .catch((err) => null);
  //     if (res) {
  //       setNASCred(res)
  //       if (res.port) {
  //         setUpdateNas(true)
  //       }else{
  //         setUpdateNas(false)
  //       }
  //     }else{
  //       setUpdateNas(false)
  //     }
  //   };
  //   x();
  // }, [uploadNasModal]);

  const setValue = (e) =>{
    setNASCred({...nasCred, [e.target.name] : e.target.value})
  }

  return (
    <div style={{ margin: "15px" }}>
       <Navbar activeTab={activeTab} />
     
      <div>
        <div className="pad-15 mt-5">
          <div className="form-boxdiv">
            <div className="form-boxtopline5">Remote Backup Location</div>
            {update ? (
              <div>
                <div className="font-size-16 p-3">
                  <h5>Current Remote databse Backup Location:</h5>
                  <div className="font-size-16">
                    <ul>
                      <li style={{ color: "black" }}>
                        IP: {host}
                      </li>
                      <li style={{ color: "black" }}>
                        Location on remote: {location}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className=" d-flex m-4 justify-content-center">
                  <button
                    className="btn btn-success"
                    data-toggle="modal"
                    data-target="#formModal"
                    onClick={toggleUploadModal}
                  >
                    Edit
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="font-size-16 p-3">
                  You have not added any remote database backup location click
                  on the below button to add it now.
                </div>
                <div className="d-flex m-4 justify-content-center">
                  <button
                    className="btn btn-success"
                    data-toggle="modal"
                    data-target="#formModal"
                    onClick={toggleUploadModal}
                  >
                    Add
                  </button>
                </div>
              </div>
            )}
            <Modal isOpen={uploadModal} toggle={cancle}>
              <ModalHeader toggle={cancle}>
                Save database backup location
              </ModalHeader>
              <ModalBody>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveBackupLocation();
                  }}
                >
                  <div className="form-boxtopcont">
                    <div className="row">
                      <div className="col-sm-6" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            IP : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            required
                            className="form-control"
                            type="text"
                            name="server_ip"
                            placeholder="IP"
                            value={host}
                            onChange={(e) => {
                              let string = e.target.value.split(":")[0];
                              if (string.match(/[^0-9.]/)) {
                                return;
                              }
                              let count = 0;
                              for (let i = 0; i < string.length; i++) {
                                if (string.charAt(i) === ".") {
                                  count++;
                                }
                              }
                              if (count > 3) {
                                return;
                              }
                              let x = string.split(".");
                              for (let i = 0; i < x.length; i++) {
                                if (x[i].length > 3) {
                                  return;
                                }
                                if (Number.parseInt(x[i]) > 255) {
                                  return;
                                }
                              }
                              setHost(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Backup Location :<i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            required
                            className="form-control"
                            type="text"
                            name="backup_location"
                            placeholder="/home/vcdms/backup"
                            value={location}
                            onChange={(e) => {
                              setlocation(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Username : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="user"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => {
                              setusername(e.target.value);
                            }}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Password : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={pass}
                            required
                            onChange={(e) => {
                              setPass(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Port : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="number"
                            placeholder="Port"
                            value={port}
                            required
                            onChange={(e) => {
                              if (
                                e.target.value.match(/[^0-9]/) === null &&
                                e.target.value.length <= 5
                              ) {
                                setPort(e.target.value);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-dismiss="modal"
                      onClick={() => {
                        if ((update?(host||pass||location||username||port):update)) {
                          setHost("");
                          setPass("");
                          setlocation("");
                          setusername("");
                          setPort("");
                        } else {
                          cancle()
                        }
                      }}
                    >
                      {(update?(host||pass||location||username||port):update)? "Reset" : "Cancel"}
                    </button>
                    <button type="submit" className="btn btn-success">
                      {update ? "Edit" : "Save"}
                    </button>
                  </div>
                </form>
              </ModalBody>
            </Modal>
          </div>
          {/* <div className="form-boxdiv">
            <div className="form-boxtopline5">NAS Location</div>
            {updateNas ? (
              <div>
                <div className="font-size-16 p-3">
                  <h5>Current NAS Backup Location:</h5>
                  <div className="font-size-16">
                    <ul>
                      <li style={{ color: "black" }}>
                        IP: {nasCred.host}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className=" d-flex m-4 justify-content-center">
                  <button
                    className="btn btn-success"
                    data-toggle="modal"
                    data-target="#formModal"
                    onClick={toggleUploadNasModal}
                  >
                    Edit
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="font-size-16 p-3">
                  You have not added any NAS location, click on the below button to add it now.
                </div>
                <div className="d-flex m-4 justify-content-center">
                  <button
                    className="btn btn-success"
                    data-toggle="modal"
                    data-target="#formModal"
                    onClick={toggleUploadNasModal}
                  >
                    Add
                  </button>
                </div>
              </div>
            )}
            <Modal isOpen={uploadNasModal} toggle={cancleNas}>
              <ModalHeader toggle={cancleNas}>
                Save NAS Credentials
              </ModalHeader>
              <ModalBody>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveNASCred();
                  }}
                >
                  <div className="form-boxtopcont">
                    <div className="row">
                      <div className="col-sm-6" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            IP : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            required
                            className="form-control"
                            type="text"
                            name="host"
                            placeholder="IP"
                            value={nasCred.host}
                            onChange={(e) => {
                              let string = e.target.value.split(":")[0];
                              if (string.match(/[^0-9.]/)) {
                                return;
                              }
                              let count = 0;
                              for (let i = 0; i < string.length; i++) {
                                if (string.charAt(i) === ".") {
                                  count++;
                                }
                              }
                              if (count > 3) {
                                return;
                              }
                              let x = string.split(".");
                              for (let i = 0; i < x.length; i++) {
                                if (x[i].length > 3) {
                                  return;
                                }
                                if (Number.parseInt(x[i]) > 255) {
                                  return;
                                }
                              }
                              setValue(e);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Username : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="username"
                            placeholder="Username"
                            value={nasCred.username}
                            onChange={(e) => {
                              setValue(e)
                            }}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Password : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={nasCred.password}
                            required
                            onChange={(e) => {
                              setValue(e);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4" style={{ padding: "0 5px" }}>
                        <div className="form-group">
                          <label className="form-check-label">
                            Port : <i style={{ color: "red" }}>*</i>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="port"
                            placeholder="Port"
                            value={nasCred.port}
                            required
                            onChange={(e) => {
                              if (
                                e.target.value.match(/[^0-9]/) === null &&
                                e.target.value.length <= 5
                              ) {
                                setValue(e);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-dismiss="modal"
                      onClick={() => {
                        if ((updateNas?(nasCred.host||nasCred.pass ||nasCred.username||nasCred.port):updateNas)) {
                          let newNasCred = Object.keys(nasCred).reduce((acc, k) => {
                            acc[k] = "";
                            return acc;
                          }, {});
                          
                          setNASCred(newNasCred);
                        } else {
                          cancleNas()
                        }
                      }}
                    >
                      {(updateNas?(nasCred.host||nasCred.pass ||nasCred.username||nasCred.port):updateNas)? "Reset" : "Cancel"}
                    </button>
                    <button type="submit" className="btn btn-success">
                      {updateNas ? "Edit" : "Save"}
                    </button>
                  </div>
                </form>
              </ModalBody>
            </Modal>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BackupLocation;
